import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _global$window;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Utils
import { getPrismicLocale, isValidLocale } from '../../../../locales/localeTypes';
import { getCookie } from '../../../../util/cookieUtil';
import { createQueryString, getParams } from '../../../../util/urlUtil';
import { getSessionUtmParams } from '../../../../util/utmHelper';
var ARRIVAL_AVENUE_STORAGE_KEY = 'arrival_avenue';
export var getPreferredRegistrationLocale = function getPreferredRegistrationLocale(fallbackLocale) {
  var _globalThis$navigator;
  // On the server, just use the fallback locale. (this will only get hit in server-side rendering,
  // which will never lead to a registration submission, so this won't get sent anywhere)
  if (typeof document === 'undefined') return fallbackLocale;

  // The visitor's explicit language choice. This cookie gets set whenever
  // the language switcher is used.
  var savedLocale = getCookie('X-MN-Locale');
  if (isValidLocale(savedLocale)) return savedLocale;

  // Browser language values may include a region (for example, `fr-FR`).
  // Match against the supported base locale before falling back to the page.
  var browserLocale = (_globalThis$navigator = globalThis.navigator) === null || _globalThis$navigator === void 0 || (_globalThis$navigator = _globalThis$navigator.language) === null || _globalThis$navigator === void 0 ? void 0 : _globalThis$navigator.split('-')[0].toLowerCase();
  if (isValidLocale(browserLocale)) return browserLocale;

  // The locale of the rendered page (`<html lang>`). Will always be a valid locale.
  return fallbackLocale;
};
export var getPersistedSessionArrivalAvenue = function getPersistedSessionArrivalAvenue() {
  if (!window.sessionStorage) return 'unknown';
  return window.sessionStorage.getItem(ARRIVAL_AVENUE_STORAGE_KEY);
};
var setPersistedSessionArrivalAvenue = function setPersistedSessionArrivalAvenue(arrivalAvenue) {
  if (!window.sessionStorage) return;
  return window.sessionStorage.setItem(ARRIVAL_AVENUE_STORAGE_KEY, arrivalAvenue);
};
export var determineSessionArrivalAvenue = function determineSessionArrivalAvenue() {
  var params = getParams(window.location.search);

  // Invite code
  if (params.invite) return 'board invite';

  // Referral code
  if (params.referrer) return 'referral';
  var path = window.location.pathname;

  // Home page
  if (path === '/') return 'home page';

  // Sub path
  return path;
};
export var persistSessionArrivalAvenue = function persistSessionArrivalAvenue() {
  var persistedSessionArrivalAvenue = getPersistedSessionArrivalAvenue();

  // If we've already persisted the session arrival location - don't persist again
  if (persistedSessionArrivalAvenue) return;
  var arrivalAvenue = determineSessionArrivalAvenue();
  setPersistedSessionArrivalAvenue(arrivalAvenue);
};
var config = (_global$window = global.window) === null || _global$window === void 0 ? void 0 : _global$window.__config;
export var getInitialValuesFromQueryString = function getInitialValuesFromQueryString() {
  var params = _objectSpread(_objectSpread({}, getSessionUtmParams()), getParams(window.location.search));
  return {
    onboarding: params.onboarding,
    successRedirect: params.success_redirect,
    segments: params.segments && params.segments.split(','),
    inviteCode: params.invite,
    referrerCode: params.referrer,
    marketingReferralCode: params.r || params.ref || params.referrer,
    example: params.example,
    featureFlags: params.feature_flags,
    agreeToTerms: false,
    subscribeToProductUpdates: false
  };
};
export var getSocialSignInUrl = function getSocialSignInUrl(vendor, locale) {
  var currentQueryParams = getParams(window.location.search);
  var appLocale = getPrismicLocale(locale);
  var queryParams = createQueryString(_objectSpread(_objectSpread({
    // Pass in origin, so that users will be redirected back the page they were on when authentication fails
    origin: encodeURIComponent(window.location.href)
  }, currentQueryParams), {}, {
    "with": vendor,
    appLocale: appLocale
  }));
  return "".concat(config.appUrl, "/register-terms").concat(queryParams);
};